import styled from "styled-components";

export const Card = styled.div`
  width: 100%;
  border: 1px solid lightgrey;
  background-color: white;
  border-radius: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  @media screen and (max-width: 794px) {
    display: ${(props) => (props.hideMobile ? "none" : "flex")};
    margin-left: -10px;
  }

  @media screen and (max-width: 992px) {
    margin-left: -10px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
  align-items: stretch;

  @media screen and (max-width: 992px) {
    flex-direction: ${(props) => (props.bypassBreakpoint ? "row" : "column")};
  }
`;

export const ImagePortrait = styled.img`
  height: 70vh;
`;

export const ImageLandscape = styled.img`
  width: 70vw;
`;
